import dayjs from 'dayjs';
import { useState } from 'react';

import { useShowMore } from 'hooks';
import { Flex } from 'components/flex';
import { formatDate } from 'utils/date';
import { EventCheckout } from 'store/api/event';
import { formatPrice, joinStrings } from 'utils/helpers';
import { TemplateList } from 'components/transactions-list';
import { SaleDetailsDrawer } from 'components/sale-details-drawer';

import { SalesListProps } from './types';

export const salesConfig = {
  template: 'repeat(5, 1fr)',
  headers: ['Location', 'Date & Time', 'Invoice', 'Net Sale', 'Employee'],
  cellsMobile: [
    { row: '1/2', col: '1/3' },
    { row: '2/3', col: '1/2' },
    { row: '2/3', col: '2/3' },
  ],
};

export const SalesList = ({
  data,
  loadMoreProps,
  drawerProps,
  withoutDetails,
}: SalesListProps) => {
  const [selectedReceipt, setSelectedReceipt] = useState<EventCheckout>();

  const { visibleData, ...showMoreProps } = useShowMore(data);

  const rows = loadMoreProps ? data : visibleData;

  return (
    <>
      <TemplateList<EventCheckout>
        {...salesConfig}
        title="Sales"
        subtitle={
          loadMoreProps
            ? `${rows?.length ?? 0} of ${loadMoreProps.totalCount} shown`
            : undefined
        }
        data={rows}
        hasMinHeight={false}
        listProps={loadMoreProps ?? showMoreProps}
        tabletTemplate={salesConfig.template}
        maxHeight={rows?.length ? 350 : undefined}
        onClick={
          !withoutDetails ? (e, value) => setSelectedReceipt(value) : undefined
        }
        render={(sale) => {
          const timezoneDate = dayjs(sale.createdAt).tz(
            sale.event?.timezone?.code
          );
          return [
            sale.event?.name,
            <Flex flexDirection="column">
              <p>{formatDate(timezoneDate)}</p>
              <p>{formatDate(timezoneDate, 'LT')}</p>
            </Flex>,
            sale.id,
            formatPrice(sale.subTotal),
            joinStrings(
              sale?.commissions?.map((commission) => commission.user?.name) ||
                [],
              ', '
            ),
          ];
        }}
      />

      <SaleDetailsDrawer
        {...drawerProps}
        selectedReceipt={selectedReceipt}
        setSelectedReceipt={setSelectedReceipt}
      />
    </>
  );
};
